import getter from '../getter';
export default function getColumns(entity) {
    return getter(entity, 'columns') || [];
}
